var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',[_c('a-layout-header',{staticClass:"userheader-wrap",style:({
    width: '100%',
    height: '64px',
    background: '#f1c331 !important',
  })},[_c('Header')],1),_c('a-layout',[_c('a-layout-sider',{staticClass:"usersider-wrap",style:({
      background: 'white !important',
    })},[_c('Sider')],1),_c('a-layout-content',{style:({
      background: 'white !important',
    })},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }